import { ChartType, } from '../../../../../../types/savedCharts';
export const getTreemapChartConfig = ({ queryTool, metricQuery, }) => {
    const { chartConfig } = queryTool;
    return {
        type: ChartType.TREEMAP,
        config: {
            groupFieldIds: chartConfig?.treemapGroupFieldIds ??
                queryTool.queryConfig.dimensions,
            sizeMetricId: chartConfig?.treemapSizeMetricId ??
                chartConfig?.yAxisMetrics?.[0] ??
                metricQuery.metrics[0],
            colorMetricId: chartConfig?.treemapColorMetricId ?? metricQuery.metrics[1],
        },
    };
};
//# sourceMappingURL=treemap.js.map